// this hack is to enable proper asset host lookups for chunked packs
// see https://webpack.js.org/guides/public-path/
/* eslint-disable camelcase, no-undef */
const assethost = document?.getElementById('react')?.dataset?.assethost;
if (assethost) {
  __webpack_public_path__ = `//${assethost}/packs/`;
}
